module.exports = __webpack_public_path__ + "img/photosession_1_12.48e5bb89.jpg";